import React from 'react';
import { TrendingUp, Mail, Twitter, Youtube, Facebook } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300 py-12 px-4">
      <div className="container mx-auto max-w-7xl">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-lg flex items-center justify-center">
                <TrendingUp className="w-6 h-6 text-white" />
              </div>
              <span className="text-xl font-bold text-white">ProfitPath</span>
            </div>
            <p className="text-sm text-gray-400">
              Your trusted source for high-converting affiliate products and proven strategies.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <button onClick={() => document.getElementById('products').scrollIntoView({ behavior: 'smooth' })} className="hover:text-emerald-400 transition-colors">
                  Top Products
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('how-it-works').scrollIntoView({ behavior: 'smooth' })} className="hover:text-emerald-400 transition-colors">
                  How It Works
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('testimonials').scrollIntoView({ behavior: 'smooth' })} className="hover:text-emerald-400 transition-colors">
                  Success Stories
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('faq').scrollIntoView({ behavior: 'smooth' })} className="hover:text-emerald-400 transition-colors">
                  FAQ
                </button>
              </li>
              <li>
                <a href="/dashboard" className="hover:text-emerald-400 transition-colors">
                  Dashboard
                </a>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-white font-semibold mb-4">Resources</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="hover:text-emerald-400 transition-colors">Affiliate Networks</a></li>
              <li><a href="#" className="hover:text-emerald-400 transition-colors">Marketing Guides</a></li>
              <li><a href="#" className="hover:text-emerald-400 transition-colors">Traffic Strategies</a></li>
              <li><a href="#" className="hover:text-emerald-400 transition-colors">Conversion Tips</a></li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="text-white font-semibold mb-4">Stay Updated</h3>
            <p className="text-sm text-gray-400 mb-4">
              Get weekly updates on new high-converting products
            </p>
            <button
              onClick={() => document.getElementById('email-capture').scrollIntoView({ behavior: 'smooth' })}
              className="w-full bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-2 rounded-lg font-semibold transition-colors text-sm"
            >
              Subscribe Now
            </button>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-gray-400">
              © {currentYear} ProfitPath. All rights reserved. | <a href="#" className="hover:text-emerald-400">Privacy Policy</a> | <a href="#" className="hover:text-emerald-400">Terms of Service</a>
            </div>

            {/* Social Links */}
            <div className="flex items-center space-x-4">
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-emerald-600 rounded-full flex items-center justify-center transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-emerald-600 rounded-full flex items-center justify-center transition-colors">
                <Youtube className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-emerald-600 rounded-full flex items-center justify-center transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-emerald-600 rounded-full flex items-center justify-center transition-colors">
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Disclaimer */}
          <div className="mt-6 text-xs text-gray-500 text-center">
            <p>
              Disclaimer: Results may vary. Earnings depend on individual effort, strategy, and market conditions. 
              This site may receive affiliate commissions from recommended products.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
